// Utility functions
const $ = selector => document.querySelector(selector);

class ProductForm {
  constructor() {
    // Find form by section ID since there may be multiple forms
    const productInfo = document.querySelector('product-info');
    const sectionId = productInfo?.dataset.section;
    this.form = document.getElementById(`product-form-${sectionId}`);
    
    if (!this.form) return;

    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.init();
  }

  init() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (this.submitButton) {
      this.submitButton.setAttribute('disabled', true);
    }

    try {
      const formData = new FormData(this.form);
      const formDataObj = {};
      
      // Convert FormData to object, handling arrays properly
      for (let [key, value] of formData.entries()) {
        if (formDataObj[key]) {
          if (!Array.isArray(formDataObj[key])) {
            formDataObj[key] = [formDataObj[key]];
          }
          formDataObj[key].push(value);
        } else {
          formDataObj[key] = value;
        }
      }

      console.log('Sending request to /cart/add.js...');
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataObj)
      });

      console.log('Response status:', response.status);
      const responseData = await response.json();
      console.log('Response data:', responseData);

      if (!response.ok) {
        console.error('Server returned error:', responseData);
        throw new Error('Add to cart failed');
      }

      // Update rewards if available
      try {
        console.log('Updating rewards...');
        await window.rewardAutomation?.updateRewardStatus();
        console.log('Rewards updated successfully');
      } catch (error) {
        console.error('Error updating rewards:', error);
      }

      // Use the global miniCart instance to open the cart drawer
      console.log('Opening cart...');
      if (window.miniCart) {
        window.miniCart.openDrawer();
        await window.miniCart.refreshCart();
      } else {
        console.warn('miniCart not found, falling back to window.openCart');
        if (typeof window.openCart === 'function') {
          window.openCart();
        }
      }

    } catch (error) {
      console.error('Error adding to cart:', error);
      console.error('Stack trace:', error.stack);
    } finally {
      if (this.submitButton) {
        this.submitButton.removeAttribute('disabled');
      }
    }
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductForm();
});
